import { useState } from "react";
import { LinkOutlined } from "@ant-design/icons";
import { Form, InputNumber } from "../ui";
import { FormDrawer } from "../components/FormDrawer";
import { ListIconAction } from "../components/ListIconAction";
import { useFeedback } from "../feedback/useFeedback";
import { MerchantPaymentLinkDrawer } from "./MerchantPaymentLinkDrawer";
import { merchantPaymentError } from "./merchantPaymentError";
import type { MerchantPaymentLink } from "./merchantPaymentContracts";
import { useFormDirty } from "../forms/useFormDirty";

export function MerchantPaymentLinkAction({ create, tr, amountRequired = false }: {
  create: (amount?: number) => Promise<MerchantPaymentLink>; tr: (key: string) => string; amountRequired?: boolean;
}) {
  const feedback = useFeedback(); const [link, setLink] = useState<MerchantPaymentLink | null>(null);
  const [saving, setSaving] = useState(false); const [amountOpen, setAmountOpen] = useState(false);
  const [form] = Form.useForm<{ amount: number }>();
  const draft = useFormDirty(form);
  const execute = async (amount?: number) => {
    setSaving(true);
    try { setLink(await create(amount)); setAmountOpen(false); }
    catch (error) { feedback.error(merchantPaymentError(error, tr)); } finally { setSaving(false); }
  };
  return <>
    <ListIconAction icon={<LinkOutlined />} label={tr("merchantPayments.createLink")} disabled={saving}
      onClick={() => { if (amountRequired) { form.resetFields(); draft.resetDirty(); setAmountOpen(true); } else return execute(); }} />
    <FormDrawer open={amountOpen} dirty={draft.dirty} title={tr("merchantPayments.WalletTopUps")} onCancel={() => setAmountOpen(false)}
      formId="merchant-payment-amount" submitting={saving} submitText={tr("merchantPayments.createLink")} cancelText={tr("merchantPayments.cancel")}>
      <Form id="merchant-payment-amount" form={form} layout="vertical" onFinish={values => execute(values.amount)}>
        <Form.Item name="amount" label={tr("merchantPayments.amount")} rules={[{ required: true, type: "number", min: 0.01, message: tr("merchantPayments.required") }]}>
          <InputNumber min={0.01} precision={2} />
        </Form.Item>
      </Form>
    </FormDrawer>
    <MerchantPaymentLinkDrawer link={link} onClose={() => setLink(null)} tr={tr} />
  </>;
}
